import Balancer from 'react-wrap-balancer';
import { IFeatureProps, ISectionHedearProps } from '../types';

export const SectionHeading: React.FC<ISectionHedearProps> = ({
  title,
  description,
}: ISectionHedearProps) => (
  <header className="mx-auto max-w-5xl space-y-5">
    <h3 className="text-brand-secondary numeric-font-fix text-center text-4xl font-extrabold md:text-5xl">
      <Balancer>{title}</Balancer>
    </h3>
    {description && (
      <p className="mx-auto max-w-5xl text-center text-xl md:text-2xl">
        <Balancer ratio={1}>{description}</Balancer>
      </p>
    )}
  </header>
);

export const FeatureBlock: React.FC = ({
  title,
  description,
  icon,
}: IFeatureProps) => (
  <div className="flex w-full flex-col items-center justify-center space-y-4 p-4">
    <div className="flex items-center justify-center rounded-full bg-white p-5">
      {icon}
    </div>
    <h3 className="text-center text-xl font-bold">{title}</h3>
    <p className="text-center">
      <Balancer>{description}</Balancer>
    </p>
  </div>
);
